<template>
	<div class="floating_group" :style="{width: expand ? '200px' : '60px'}" @mouseleave="handleMouseLeave">
		<div class="item" :class="{'item_expand': expand}" style="cursor: pointer;" @click="handleToTop" @mouseenter="handleMouseEnter">
			<div class="item_t"><i class="icon icon_toTop"></i>回到顶部</div>
		</div>
		<div class="line clear_both">
			<div class="line_box" :class="{'line_expand': expand}" @mouseenter="handleMouseEnter"></div>
		</div>
		<div class="item" :class="{'item_expand': expand}" @mouseenter="handleMouseEnter">
			<!-- <div class="item_t"><i class="icon icon_phone"></i>0551-68562028</div> -->
			<div class="item_t"><i class="icon icon_phone"></i>18599158171</div>
			
		</div>
		<div class="line clear_both">
			<div class="line_box" :class="{'line_expand': expand}" @mouseenter="handleMouseEnter"></div>
		</div>
		<div class="item item_third" :class="{'item_expand': expand}" @mouseenter="handleMouseEnter">
			<div class="item_t"><i class="icon icon_code"></i>微信二维码</div>
			<div class="item_b">
				<img src="../../../assets/customer_code.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				expand: false
			}
		},
		methods: {
			/***************** @Events *********************/
			// 鼠标移入
			handleMouseEnter() {
				this.expand = true;
			},
			// 鼠标移出
			handleMouseLeave() {
				this.expand = false;
			},
			// 返回顶部
			handleToTop() {
				let ele = document.documentElement || document.body;
				ele.scrollTop = 0;
			}
		}
	}
</script>

<style scoped>
	.floating_group{ position: fixed;z-index: 150;top: 200px;right: 0;transition: all .3s ease-out; }
	.floating_group .item{ position: relative;width: 100%;height: 60px;border-radius: 4px;overflow: hidden;transition: all .3s ease-out; }
	.floating_group .item_expand.item_third{ height: 240px; }
	.floating_group .item_t{ position: absolute;width: 100%;top: 0;right: 0;padding: 0 0 0 60px;background: #ffb805;color: #fff;line-height: 60px;white-space: nowrap; }
	.floating_group .icon{ display: block;position: absolute;width: 60px;height: 60px;top: 0;left: 0;background-size: 34px 34px;background-repeat: no-repeat;background-position: center center; }
	.floating_group .icon_toTop{ background-image: url(../../../assets/to_top.png); }
	.floating_group .icon_phone{ background-image: url(../../../assets/phone_icon.png); }
	.floating_group .icon_code{ background-image: url(../../../assets/code.png); }
	.floating_group .item_b{ position: absolute;width: 100%;height: 0;top: 60px;right: 0;padding: 0 20px 20px;background: #ffb805;transition: all .3s ease-out; }
	.floating_group .item_expand .item_b{ height: 180px; }
	.floating_group .item_b img{ display: block;width: 100%;height: 100%; }
	.floating_group .item_expand .item_b img{ height: 160px; }
	.floating_group .line_box{ float: right;width: 60px;height: 3px;transition: all .3s ease-out; }
	.floating_group .line_expand{ width: 200px; }
</style>
